import React from 'react';
import LegalPdfPage from './LegalPdfPage';

const PrivacyPolicy: React.FC = () => (
    <LegalPdfPage
        title="Política de Privacidad"
        iframeTitle="Política de Privacidad"
        pdfUrl="https://podscope.s3.us-east-1.amazonaws.com/legal/PP.pdf"
    />
);

export default PrivacyPolicy;
